import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import VocabPracticeApp from "./VocabPracticeApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <VocabPracticeApp />
  </React.StrictMode>
);
